import { useCallback, useState } from "react";
import { stripAdvancedSearchFilters } from "@utils/searchHelpers";

export function useAdvancedSearch({
  searchFields,
  quickSearchField,
  setSearchCriteria,
  initialCriteria,
  onOpen,
  onPanelClose,
}) {
  const [showAdvancedSearch, setShowAdvancedSearch] = useState(false);

  const handleAdvancedSearchToggle = useCallback(() => {
    setShowAdvancedSearch((prev) => {
      const next = !prev;
      if (next) {
        onOpen?.();
      } else if (onPanelClose) {
        onPanelClose();
      } else if (setSearchCriteria && searchFields) {
        setSearchCriteria((prevCriteria) =>
          stripAdvancedSearchFilters(prevCriteria, {
            searchFields,
            quickSearchField,
            initialCriteria,
          }),
        );
      }
      return next;
    });
  }, [searchFields, quickSearchField, setSearchCriteria, initialCriteria, onOpen, onPanelClose]);

  return { showAdvancedSearch, setShowAdvancedSearch, handleAdvancedSearchToggle };
}
